function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpatula(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "50px",
    width: "50px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.99 511.99",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90, 255.995, 255.995)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#434A54"
    },
    points: "208.681,341.028 170.971,303.31 359.084,115.198 396.801,152.908 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#656D78"
    },
    d: "M148.26,499.493c-16.664,16.655-43.679,16.655-60.342,0l-75.42-75.421 c-16.664-16.671-16.664-43.686,0-60.342l75.42-75.42c0,0,88.693-31.983,127.95,7.266c39.265,39.265,7.812,128.496,7.812,128.496 L148.26,499.493z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0",
    style: {
      fill: "#ED5564"
    },
    d: "M505.642,6.349c-14.266-14.273-60.327,0-60.327,0l-67.889,82.967l-60.343,60.342 l45.266,45.249l59.857-59.866l83.436-68.35C505.642,66.691,519.924,20.63,505.642,6.349z M475.752,51.871 c-4.172,4.164-10.922,4.164-15.093,0c-4.156-4.164-4.156-10.922,0-15.086c4.171-4.164,10.921-4.164,15.093,0 C479.908,40.95,479.908,47.707,475.752,51.871z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_",
    style: {
      fill: "#ED5564"
    },
    d: "M505.642,6.349c-14.266-14.273-60.327,0-60.327,0l-67.889,82.967 l-60.343,60.342l45.266,45.249l59.857-59.866l83.436-68.35C505.642,66.691,519.924,20.63,505.642,6.349z M475.752,51.871 c-4.172,4.164-10.922,4.164-15.093,0c-4.156-4.164-4.156-10.922,0-15.086c4.171-4.164,10.921-4.164,15.093,0 C479.908,40.95,479.908,47.707,475.752,51.871z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M125.628,341.106L125.628,341.106c4.164-4.172,4.164-10.922,0-15.094 c-4.164-4.156-10.914-4.156-15.085,0v0.016l-60.335,60.327l0,0c-4.164,4.172-4.164,10.922,0,15.094 c4.164,4.155,10.914,4.155,15.085,0L125.628,341.106L125.628,341.106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M185.97,386.355c-4.172-4.172-10.921-4.156-15.085,0l0,0l0,0l-60.342,60.342l0,0l0,0 c-4.164,4.172-4.164,10.922,0,15.078c4.164,4.172,10.921,4.172,15.085,0l0,0l60.342-60.326 C190.134,397.277,190.134,390.527,185.97,386.355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M155.799,371.277L155.799,371.277L155.799,371.277c4.164-4.172,4.164-10.922,0-15.094 c-4.164-4.156-10.922-4.156-15.085,0l0,0l0,0L80.38,416.526l0,0c-4.164,4.172-4.172,10.921,0,15.077 c4.164,4.172,10.914,4.172,15.078,0h0.008l0,0L155.799,371.277z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DA4453"
    },
    d: "M407.598,134.573c-4.172,4.164-4.172,10.914,0,15.078v0.008l14.609-14.617l0.516-0.422 c-0.016-0.016-0.031-0.031-0.047-0.047C418.519,130.401,411.769,130.409,407.598,134.573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DA4453"
    },
    d: "M377.427,89.316L377.427,89.316l-15.077,15.086c4.155,4.164,10.905,4.164,15.077,0 S381.599,93.48,377.427,89.316L377.427,89.316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DA4453"
    },
    d: "M377.786,195.259c-4.172,4.171-10.922,4.171-15.093,0l-45.25-45.249 c-4.172-4.164-4.172-10.921,0-15.085c4.156-4.164,10.922-4.164,15.078,0l45.265,45.257 C381.942,184.345,381.942,191.095,377.786,195.259z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpatula);
export default __webpack_public_path__ + "static/media/spatula.12ede00db7502f229d12270d27af8c33.svg";
export { ForwardRef as ReactComponent };